module.exports = __webpack_public_path__ + "img/slide-4.98b0f776.webp";